import React, { PropsWithChildren } from 'react';
import './DrawerFormContainer.scss';
import { Button, Drawer, Grid } from 'antd';
import { useTranslation } from 'react-i18next';
import { CloseOutlined } from '@ant-design/icons';
import NeedHelp from '../needHelp/NeedHelp';

interface DrawerFormContainerProps {
  title: string;
  description?: string;
  visible: boolean;
  onClose: () => void;
  onSave?: () => void;
  cancelButtonTitle?: string;
  saveButtonTitle?: string;
  width?: number | string;
  isSubmitting?: boolean;
  isSaveButtonDisabled?: boolean;
}

const DrawerFormContainer: React.FC<
  PropsWithChildren<DrawerFormContainerProps> & DrawerFormContainerProps
> = ({
  title,
  description,
  visible,
  onClose,
  onSave,
  cancelButtonTitle,
  saveButtonTitle,
  children,
  width = 500,
  isSubmitting = false,
  isSaveButtonDisabled = false,
}) => {
  const { t } = useTranslation('common');
  const screens = Grid.useBreakpoint();

  const handleCancel = () => {
    onClose();
  };

  const handleSave = () => {
    onSave?.();
  };

  return (
    <Drawer
      title={null}
      placement="right"
      onClose={onClose}
      open={visible}
      width={screens.xs ? '100%' : width}
      closable={false}
      className="drawer-form-container-drawer"
    >
      <div className="drawer-form-container">
        {/* Header */}
        <div className="drawer-header">
          {!screens.xs && (
            <div className="close-button-container">
              <Button
                type="link"
                icon={<CloseOutlined />}
                onClick={handleCancel}
                className="close-button"
              />
            </div>
          )}
          <div className="drawer-title">
            {title}{' '}
            {
              screens.xs && (
                <Button
                  type="link"
                  icon={<CloseOutlined />}
                  onClick={handleCancel}
                  className="close-button"
                />
              )
            }

          </div>
          {description && (
            <div className="drawer-description">{description}</div>
          )}
        </div>

        <div className="drawer-content">
          {children}

          <div className="drawer-footer">
            {/* Help Section */}
            <NeedHelp />

            <div className="button-section">
              <Button
                size="large"
                onClick={handleCancel}
                className="cancel-button"
                color="primary"
                variant="outlined"
                disabled={isSubmitting}
              >
                {cancelButtonTitle || t('button.cancel')}
              </Button>
              <Button
                type="primary"
                size="large"
                onClick={handleSave}
                loading={isSubmitting}
                className="save-button"
                disabled={isSaveButtonDisabled}
              >
                {saveButtonTitle || t('button.save')}
              </Button>
            </div>
          </div>

        </div>


      </div>
    </Drawer>
  );
};

export default DrawerFormContainer;
